import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { environment } from 'environments/environment';

export class IAppConfig {
  requestsWithDynamicForms: boolean;
  rebranding: boolean;
}

export let APP_CONFIGS: IAppConfig;

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private readonly headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    this.headers = new HttpHeaders();
    this.headers = this.headers.append('Content-Type', 'application/json');
    this.headers = this.headers.append('Project-Code', environment.appConfig.projectCode);
    this.headers = this.headers.append('Api-Key', environment.appConfig.apiKey);
  }

  load(): Observable<boolean> {
    return this.http
      .post(`${environment.apiUrlMs}/appconfig/features`, { args: { loading: 'off' } }, { headers: this.headers })
      .pipe(
        map((response: any) => {
          APP_CONFIGS = response.Body.Result as IAppConfig;

          return true;
        }),
        catchError((err) => {
          return of(false);
        })
      );
  }
}
